import "./SmallBusinessSeo.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Priorities from "./sections/Priorities";
import QuickLinks from "./sections/QuickLinks";
import Footer from "@/reusable_sections/Footer";
export default function SmallBusinessSeoPage() {
  return <div>
      <Header />
      <Hero />
      <Priorities />
      <QuickLinks />
      <Footer />
    </div>;
}